import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Nav } from 'react-bootstrap';
import RuleSetsSection from './sections/RuleSetsSection';
import MetadataFieldsSection from './sections/MetadataFieldsSection';
import ReferenceFilesSection from './sections/ReferenceFilesSection';
import AugmentationRulesSection from './sections/AugmentationRulesSection';
import DeliveryConfigurationSection from './sections/DeliveryConfigurationSection';

/**
 * CustomerConfigurationTabs - Tabbed interface for customer-specific configurations
 * 
 * Provides navigation between different configuration sections:
 * - Rule Sets: Manage extraction rule sets for the customer
 * - Metadata Fields: Manage custom metadata fields
 * - Reference Files: Manage reference file configurations (placeholder)
 * - Augmentation Rules: Manage augmentation rules (placeholder)
 * - Delivery Configuration: Manage delivery endpoint and settings
 * 
 * Note: Model configuration is now global (not per-customer) and managed via Admin > Model Configuration
 * 
 * @param {string} activeTab - The currently active tab key
 * @param {function} onTabChange - Callback when tab is changed
 * @param {string} customerId - The ID of the customer
 */
const CustomerConfigurationTabs = ({ activeTab, onTabChange, customerId }) => {
  return (
    <Tab.Container activeKey={activeTab} onSelect={onTabChange}>
      <Nav variant="tabs" className="mb-3">
        <Nav.Item>
          <Nav.Link eventKey="rulesets">Rule Sets</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="metadata">Metadata Fields</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="reference">Reference Files</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="augmentation">Augmentation Rules</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="delivery">Delivery Configuration</Nav.Link>
        </Nav.Item>
      </Nav>
      
      <Tab.Content>
        <Tab.Pane eventKey="rulesets">
          {activeTab === 'rulesets' && <RuleSetsSection customerId={customerId} />}
        </Tab.Pane>
        
        <Tab.Pane eventKey="metadata">
          {activeTab === 'metadata' && <MetadataFieldsSection customerId={customerId} />}
        </Tab.Pane>
        
        <Tab.Pane eventKey="reference">
          {activeTab === 'reference' && <ReferenceFilesSection customerId={customerId} />}
        </Tab.Pane>
        
        <Tab.Pane eventKey="augmentation">
          {activeTab === 'augmentation' && <AugmentationRulesSection customerId={customerId} />}
        </Tab.Pane>
        
        <Tab.Pane eventKey="delivery">
          {activeTab === 'delivery' && <DeliveryConfigurationSection customerId={customerId} />}
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
};

CustomerConfigurationTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired
};

export default CustomerConfigurationTabs;
